module.exports = __webpack_public_path__ + "media/ApplicantSummaryMWeb.6520cf17.pdf";